import React, { useState } from "react";
import { Col, Form as FormLayout, Modal } from "react-bootstrap";
import { diffCheck } from "../../../../util/Helpers";
import { useUpdateOrderMutation } from "../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";
import { Formik, Form } from "formik";
import * as Yup from "yup"
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as handlers from "../../../UserManagement/_redux/selected-user/selectedUserHandlers";
import SelectInput from "../../../Common/components/select-input";
import TextInput from "../../../Common/components/text-input";


const EditOrderModal = ({ showEditOrderModal, onHide, details, tableRef, refreshOrders }) => {

    const [type, setType] = useState("Quantity");
    const [updateTotal, setUpdateTotal] = useState(false);
    const { userId, accountId } = useParams();
    const [showConfirmationView, setShowConfirmationView] = useState(false);
    const dispatch = useDispatch();
    

    const [
        updateOrderStatus,
        {
            isLoading: isUpdating,
        }
    ] = useUpdateOrderMutation()

    /* Update Order */
    const onSubmit = values => {
        const data = { ...values }
        if (type === "Amount") delete data["quantity"]
        if (type === "Quantity") delete data["amount"]
        if (!updateTotal) delete data["total"]

        updateOrderStatus({
            id: details?.id,
            userId: details.userId,
            ...data,
            meta: details
        })
            .unwrap()
            .then(() => {
                cogoToast.success("Order Updated Successfully")
                onHide();
                if (tableRef) {
                    tableRef.current.refresh()
                }
                else if (refreshOrders) {
                    refreshOrders();
                }
            })
    }

    return (
        <Modal
            show={showEditOrderModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isUpdating ? "static" : true}
            keyboard={!isUpdating}
        >
            <Formik
                initialValues={{
                    status: details?.status,
                    price: details?.price,
                    amount: details?.amount || 0,
                    quantity: details?.quantity || 0,
                    total: details?.total
                }}
                validationSchema={
                    Yup.object({
                        status: Yup.string().required("required"),
                        price: Yup.number().required("required"),
                        amount: Yup.number().required("required"),
                        quantity: Yup.number().required("required"),
                        total: Yup.number().required("required"),
                    })
                }
                onSubmit={(values) => onSubmit(values)}
                
            >
                {({ dirty, isValid, values }) =>
                    <Form>
                        <Modal.Header>
                            <Modal.Title id="contained-modal-title-vcenter">
                                Update Order
                            </Modal.Title>
                            <button type="button" className="close" onClick={onHide}>
                                <span aria-hidden="true" className="d-block">×</span>
                                <span className="sr-only">Close</span>
                            </button>
                        </Modal.Header>
                        <Modal.Body style={{ maxHeight: "calc(100vh - 300px)", overflow: "auto" }}>
                            {
                                showConfirmationView
                                    ? <div>

                                        

                                        <div className="row mt-4">
                                            <div className="col-md-4 h6">
                                                Symbol
                                            </div>
                                            <div className="col-md h6 text-muted">
                                                {details?.symbol}
                                            </div>
                                        </div>

                                        <div className="row mt-4">
                                            <div className="col-md-4 h6">
                                                Username
                                            </div>
                                            <div className="col-md h6 text-muted">
                                                {details?.username}
                                            </div>
                                        </div>

                                        {type === "Amount" ?

                                            <div className="row mt-4">
                                                <div className="col-md-4 h6">
                                                    Amount ({details?.currency})
                                                </div>
                                                <div className="col-md h6 text-muted">
                                                    {diffCheck(details.amount.toLocaleString('en-US', { maximumFractionDigits: 2 }),
                                                        values.amount.toLocaleString('en-US', { maximumFractionDigits: 2 }))}
                                                </div>
                                            </div>
                                            : null

                                        }
                                        <div className="row mt-4">
                                            <div className="col-md-4 h6">
                                                Status
                                            </div>
                                            <div className="col-md h6 text-muted">
                                                {diffCheck(details.status, values.status)}
                                            </div>
                                        </div>
                                        <div className="row mt-4">
                                            <div className="col-md-4 h6">
                                                Activity
                                            </div>
                                            <div className="col-md h6 text-muted">
                                                
                                                {details.side}
                                            </div>
                                            
                                        </div>
                                        
                                        <div className="row mt-4">
                                            <div className="col-md-4 h6">
                                                Price ({details?.currency})
                                            </div>
                                            <div className="col-md h6 text-muted">
                                                {diffCheck(details?.price.toLocaleString('en-US', { maximumFractionDigits: 2 }),
                                                    values.price.toLocaleString('en-US', { maximumFractionDigits: 2 }))}
                                            </div>
                                        </div>
                                        {type === "Quantity" ?
                                            <div className="row mt-4">
                                                <div className="col-md-4 h6">
                                                    Quantity
                                                </div>
                                                <div className="col-md h6 text-muted">
                                                    {diffCheck(details.quantity, values.quantity)}
                                                </div>
                                            </div>
                                            :
                                            null
                                        }

                                        
                                    </div>
                                    : <>
                                        <FormLayout.Row>
                                            <SelectInput
                                                label="Status"
                                                name="status"
                                                options={[
                                                    "COMPLETED",
                                                    "PENDING",
                                                    "MANUAL_PROCESSING",
                                                    "PARTIAL_FILL",
                                                    "ON_HOLD",
                                                    "CANCELLED",
                                                    "ON_HOLD",
                                                    "REJECTED",
                                                    "CANCELLING",
                                                    "PROCESSING",
                                                    "FAILED",
                                                ]}
                                            />
                                            <TextInput label={"Price"} type="number" step="any" name="price" />
                                        </FormLayout.Row>

                                        <FormLayout.Row>
                                            <FormLayout.Group as={Col} md="6" controlId="status">
                                                <FormLayout.Label>Volume Type</FormLayout.Label>
                                                <FormLayout.Control
                                                    required
                                                    as="select"
                                                    defaultValue={type}
                                                    className="mr-sm-2"
                                                    custom
                                                    onChange={e => setType(e.currentTarget.value)}
                                                >
                                                    <option value="Quantity">Quantity</option>
                                                    <option value="Amount">Amount</option>

                                                </FormLayout.Control>
                                                <FormLayout.Control.Feedback type="invalid">
                                                    Select the Volume Type
                                                </FormLayout.Control.Feedback>
                                            </FormLayout.Group>

                                            {
                                                type === "Quantity"
                                                    ? <TextInput label={"Quantity"} type="quantity" step="any" name="quantity" />
                                                    : <TextInput label={`Amount ${details?.currency}`} type="number" step="any" name="amount" />

                                            }
                                        </FormLayout.Row>
                                        {
                                            updateTotal &&
                                            <FormLayout.Row>
                                                <TextInput label={"Total"} type="number" step="any" name="total" />
                                                <p className="pt-2 px-2 mb-4 text-danger">
                                                    If total is entered, total will not be automatically computed and fees might not be applied
                                                </p>
                                            </FormLayout.Row>
                                        }
                                        <div className="pb-4">
                                            {
                                                updateTotal
                                                    ? <button
                                                        className="btn btn-danger btn-sm"
                                                        onClick={_ => setUpdateTotal(false)}
                                                        type="button"
                                                    >
                                                        Don't Set Total
                                                    </button>
                                                    : <button
                                                        className="btn btn-dark btn-sm"
                                                        onClick={_ => setUpdateTotal(true)}
                                                        type="button"
                                                    >
                                                        Set Total
                                                    </button>
                                            }
                                        </div>
                                    </>
                            }
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                showConfirmationView
                                    ? <button
                                        type="button"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setShowConfirmationView(false)
                                        }}
                                        disabled={isUpdating}
                                        className="btn btn-light btn-elevate px-4"
                                    >
                                        Back
                                    </button>
                                    : <button
                                        type="button"
                                        onClick={onHide}
                                        className="btn btn-light btn-elevate px-4"
                                    >
                                        Cancel
                                    </button>
                            }
                            {
                                showConfirmationView
                                    ? <button
                                        type="submit"
                                        disabled={!dirty || !isValid || isUpdating}
                                        className="btn btn-primary btn-elevate px-4 ml-4"
                                    >
                                        Confirm
                                    </button>
                                    : <button
                                        type="button"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setShowConfirmationView(true)
                                        }}
                                        disabled={!dirty || !isValid || isUpdating}
                                        className="btn btn-primary btn-elevate px-4 ml-4"
                                    >
                                        Proceed
                                    </button>
                            }
                        </Modal.Footer>
                    </Form>
                }
            </Formik>
        </Modal>
    );
}

export default EditOrderModal;
